import { Dialog } from "antd-mobile";
import React from "react";
import styles from "./index.module.less";

export default function OverviewPane({
  items,
}: {
  items: {
    label: string;
    value: string;
    unit?: string;
    tip?: string;
    valueColor?: string;
  }[];
}) {
  const onShowTip = (title: string, tip: string | undefined) => {
    if (!tip) {
      return;
    }
    Dialog.alert({
      content: tip,
      title,
      confirmText: "我知道了",
      className: "dialog__private",
    });
  };
  return (
    <div className={styles.container}>
      {items.map(item => {
        return (
          <div key={item.label} className={styles.item}>
            <div className={styles.valueWrapper}>
              <span className={styles.value} style={{ color: item.valueColor || "#F14067" }}>
                {item.value}
              </span>
              {item.unit && (
                <span className={styles.unit} style={{ color: item.valueColor || "#F14067" }}>
                  {item.unit}
                </span>
              )}
            </div>
            {
              <div className={styles.labelWrapper} onClick={() => onShowTip(item.label, item.tip)}>
                <span className={styles.label}>{item.label}</span>
                {item.tip && (
                  <img
                    src="https://akim-oss.aikucun.com/6e598eeeaca220dadb35a83855b54d9752ee582b_1747291275477_20.png"
                    className={styles.tipIcon}
                  />
                )}
              </div>
            }
          </div>
        );
      })}
    </div>
  );
}
